// Fast and robust XML formatter that wraps and indents all tags cleanly without validating
export const formatXml = (xml) => {
  if (!xml || typeof xml !== "string") return "";

  let formatted = "";
  let indent = 0;
  const tab = "  ";

  // Split by tag boundaries while keeping tokens
  const tokens = xml
    .replace(/>\s*</g, "><")
    .split(/(<[^>]+>)/g)
    .filter((t) => t.length > 0);

  tokens.forEach((token) => {
    const trimmed = token.trim();
    if (!trimmed) return;

    if (trimmed.startsWith("</")) {
      // Closing tag: decrement indent first
      indent = Math.max(0, indent - 1);
      formatted += tab.repeat(indent) + trimmed + "\n";
    } else if (
      trimmed.startsWith("<") &&
      (trimmed.endsWith("/>") ||
        trimmed.startsWith("<?") ||
        trimmed.startsWith("<!--") ||
        trimmed.startsWith("<!"))
    ) {
      // Self-closing tag or declaration / comment
      formatted += tab.repeat(indent) + trimmed + "\n";
    } else if (trimmed.startsWith("<")) {
      // Opening tag: print then increment indent
      formatted += tab.repeat(indent) + trimmed + "\n";
      indent++;
    } else {
      // Text node
      formatted += tab.repeat(indent) + trimmed + "\n";
    }
  });

  // Collapse short leaf node tags to single line: <tag>\n text\n </tag> => <tag>text</tag>
  const collapsed = formatted.replace(
    />\n\s*([^<>\n\r]{1,120})\n\s*<\//g,
    ">$1</"
  );
  return collapsed.trim();
};
